export default "__VITE_ASSET__DtiFihHm__"